import OLD_VEHICLE_SERIE from './serie.json';
import {isEmptyString, isNullOrUndefined} from '../../validators';

const NEW_VEHICLE_SERIE = {
  B: 1, C: 2, D: 3, F: 4, G: 5, H: 6, J: 7, K: 8, L: 9, P: 0, R: 2, S: 3, T: 4, V: 5, W: 6, X: 7, Y: 8, Z: 9,
};

const type = {
  CAR: 1,
  BIKE: 2,
  UNKNOWN: 3
};

export const EXP_CAR_OLD = new RegExp('^[A-Z]{2}[1-9]{1}[0-9]{3}$');
export const EXP_CAR_NEW = new RegExp('^[BCDFGHJKLPRSTVWXYZ]{4}[0-9]{2}$');

// export const EXP_MOTORCYCLE_OLD_5 = new RegExp('^[A-Z]{2}[0-9]{3}$');
// export const EXP_MOTORCYCLE_NEW_5 = new RegExp('^[BCDFGHJKLPRSTVWXYZ]{3}[0-9]{2}$');

export const EXP_MOTORCYCLE_OLD_6 = new RegExp('^[A-Z]{2}[0]{1}[0-9]{3}$');
export const EXP_MOTORCYCLE_NEW_6 = new RegExp('^[BCDFGHJKLPRSTVWXYZ]{3}[0]{1}[0-9]{2}$');

const EXP_ALPHA_NUM_WITH_DIGIT = /^[A-Za-z0-9.]+-[A-Za-z0-9]$/;

export const calcVerifierDigit = (number) => {
  const reversed = number.split('').reverse();
  let indexer = 2;
  const SP = reversed.reduce((acc, current) => {
    acc += (+current) * indexer;
    indexer = indexer === 7 ? 2 : indexer + 1;
    return acc;
  }, 0);

  const R = Math.abs(SP % 11);

  if (R > 11)
    throw new Error('Verifier Digit Number Calculation fail');

  const verifier = 11 - R;
  return verifier === 10 ? 'K' : verifier === 11 ? 0 : verifier;
};

const getType = (patent) => {
  // if (patent.match(EXP_MOTORCYCLE_OLD_5)) return type.BIKE;
  if (patent.match(EXP_MOTORCYCLE_OLD_6)) return type.BIKE;

  // if (patent.match(EXP_MOTORCYCLE_NEW_5)) return type.BIKE;
  if (patent.match(EXP_MOTORCYCLE_NEW_6)) return type.BIKE;

  if (patent.match(EXP_CAR_OLD)) return type.CAR;
  if (patent.match(EXP_CAR_NEW)) return type.CAR;

  return type.UNKNOWN;
};

export const clean = value => {
  let patent = value;

  if (value.match(EXP_ALPHA_NUM_WITH_DIGIT)) {
    patent = value.substr(0, value.length - 2);
  }

  return patent.toString().replace(/[.-]|\s/g, '').toUpperCase()
};

export const patentWithoutVerifier = value => {
  value = clean(value);

  if (value.match(EXP_ALPHA_NUM_WITH_DIGIT)) {
    return value.substr(0, value.length - 2);
  }

  return value;
};

export const calcPatentVerifier = (patent) => {
  // if (patent.match(EXP_MOTORCYCLE_OLD_5)) return oldPatentBikeVerifier(patent);
  if (patent.match(EXP_MOTORCYCLE_OLD_6)) return oldPatentBikeVerifier(patent);

  // if (patent.match(EXP_MOTORCYCLE_NEW_5)) return patentBikeVerifier(patent);
  if (patent.match(EXP_MOTORCYCLE_NEW_6)) return patentBikeVerifier(patent);

  if (patent.match(EXP_CAR_OLD)) return oldPatentVerifier(patent);
  if (patent.match(EXP_CAR_NEW)) return patentVerifier(patent);

  return false;
};

export const isZeroDigit = character => character === '0' || character === 0;
export const addZeroCharacterIfNotExist = patent => {
  const value = clean(patent);

  if (getType(value) !== type.BIKE) return value;

  if (value.match(EXP_MOTORCYCLE_OLD_6) && !isZeroDigit(value.charAt(2))) {
    return value.slice(0, 2) + '0' + value.slice(-3);
  }

  if (value.match(EXP_MOTORCYCLE_NEW_6) && !isZeroDigit(value.charAt(3))) {
    return value.slice(0, 3) + '0' + value.slice(-3);
  }

  return value;
};

export const extractSerie = (patent, digits = 4) => parseInt(patent.slice(0, digits).split('').map(v => NEW_VEHICLE_SERIE[v]).join(''));

// Bike
export const patentBikeVerifier = patent => calcVerifierDigit(extractSerie(patent, 3) + patent.slice(-3));
export const oldPatentBikeVerifier = (patent) => oldPatentVerifier(addZeroCharacterIfNotExist(patent));

// Car
export const patentVerifier = patent => calcVerifierDigit(extractSerie(patent) + patent.slice(-2));
export const oldPatentVerifier = patent => calcVerifierDigit(OLD_VEHICLE_SERIE[patent.slice(0, 2)] + patent.slice(-4));

export const formatPatent = patent => {
  if (isNullOrUndefined(patent) || isEmptyString(patent)) return "";

  const normalized = addZeroCharacterIfNotExist(patent);
  const verif = calcPatentVerifier(normalized);
  const result = verif || verif === 0 ? normalized + '-' + verif : patent;

  const removeDotCharacter = result.replace(/[.]|\s/g, '');
  const firstDigit = removeDotCharacter.match(/\d/);
  const firstDigitIndex = removeDotCharacter.indexOf(firstDigit);

  return removeDotCharacter.substring(0, firstDigitIndex) + '.' + removeDotCharacter.substring(firstDigitIndex);
};
